
<template>
  <!--人员预警-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="[]"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip placement="topLeft" :title="row.label_desc">
          <span :style="{cursor: 'pointer'}">{{row.label || row.label_desc}}</span>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'blackList',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '姓名、手机号', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '开门日志', handle: row => this.openLog(row), key: 'log' },
        { text: '修改', handle: row => this.$refs.table.toEdit(row, ['id']), key: 'edit' },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: '姓名', dataIndex: 'true_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '性别', dataIndex: 'sex', align: 'left', width: '' },
        { title: '标签', dataIndex: 'label_desc', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      searchParams: {
        keywords: ''
      },
      listApi: {
        url: '/blacklist',
        resHandle: this.resHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addBlackList',
        title: '编辑人员'
      },
      deleteParam: {
        url: 'blacklist',
        param: {pk_key: 'id', pk_val: ''},
        title: '预警人员',
        key: 'true_name'
      }
    };
  },
  mounted () {
  },
  methods: {
    /* 开门日志 */
    openLog (row) {
      this.$router.push({
        name: 'lookOpenLog',
        query: {
          id: row.member_id,
          name: row.true_name,
          label: row.label_desc
        }
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        let label = el.label_desc.split('/');
        if (label.length > 3) {
          el.label = `${label.slice(0, 3).join('/')}...`;
        }
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
